import { Select, type SelectProps } from "./Select";

export interface SearchSelectProps extends Omit<SelectProps, "isSearchable"> {}

export function SearchSelect(props: SearchSelectProps) {
  return <Select {...props} isSearchable />;
}
